import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.css'],

})
export class AddButtonComponent {
  @Input() text!: string
  @Output() click = new EventEmitter<any>()

  executeFx() {
    this.click.emit(true)
  }
}
